import { MODULE as PARENT } from '../constants'

export const KEY = 'delivery-statistics'
export const MODULE = [...[PARENT], KEY]

export const FETCH_INFO = `${MODULE.join('/')}-fetch`
export const CLEAR_INFO = `${MODULE.join('/')}-clear`
